import { machine, connect } from '@zag-js/accordion';
import { useMachine } from '@zag-js/svelte';
import { useConnect } from '../../utils/useConnect.svelte.js';
export const useAccordion = (props) => {
    const { value, ...restProps } = props;
    const stateMachine = useMachine(machine, {
        ...restProps,
        defaultValue: value
    });
    return useConnect(stateMachine, connect);
};
